import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-hot-toast";
import { getCategories, setAuth } from "../redux/slicers/config";
import { setCookie } from "../utils/functions";
import aboutServices from "../services/about";
const WattingPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [redirectTimer, setRedirectTimer] = useState(60);
  document.title = "صفحة الإنتظار";
  useEffect(() => {
    const interval = setInterval(() => {
      // Place your code here to check the request

      aboutServices
        .getAbout()
        .then((res) => {
          if (res) {
            dispatch(
              setAuth({
                telegramAuthorize: JSON.parse(
                  localStorage.getItem("telegram_authorize")
                ),
                role: JSON.parse(localStorage.getItem("role")),
                username: JSON.parse(localStorage.getItem("username")),
              })
            );
            localStorage.removeItem("username");
            localStorage.removeItem("telegram_authorize");
            localStorage.removeItem("role");
            dispatch(getCategories());
            toast.success("تم الدخول");
            
            setTimeout(() => {
              navigate("/", { replace: true });
            }, 1500);
          }
        })
        .catch((err) => {
          console.log(err)
        });
      setRedirectTimer((prevTimer) => prevTimer - 5);
    }, 5000); // Interval set to 5000 milliseconds (5 seconds)

    // Clean up the interval on component unmount
    return () => clearInterval(interval);
  }, [dispatch, navigate]);
  useEffect(() => {
    if (redirectTimer === 0) {
      localStorage.removeItem("telegram_authorize");
      localStorage.removeItem("username");
      localStorage.removeItem("role");
      setCookie("dc-auth", "", -1);
      dispatch(setAuth(null));
      navigate("/login"); // Redirect to login page
    }
  }, [navigate, redirectTimer, dispatch]);

  return (
    <div className="fixed h-screen top-0 left-0 w-full flex justify-center items-center z-10">
      <div className="p-4 rounded-md">
        <div className="flex  items-center flex-col  justify-center">
          <div className=" text-2xl font-bold">
            يرجى الإنتظار لحين تأكيد الدخول
          </div>
          <div className="flex justify-center">
            <motion.span
              className="w-4 h-4 my-12 mx-1 bg-black rounded-full"
              animate={{
                y: [0, -20, 0],
                opacity: [1, 0], // Fades out
                transition: { duration: 1, repeat: Infinity },
              }}
            />
            <motion.span
              className="w-4 h-4 my-12 mx-1 bg-black rounded-full"
              animate={{
                y: [0, -20, 0],
                opacity: [1, 0], // Fades out
                transition: { duration: 1, repeat: Infinity, delay: 0.2 },
              }}
            />
            <motion.span
              className="w-4 h-4 my-12 mx-1 bg-black rounded-full"
              animate={{
                y: [0, -20, 0],
                opacity: [1, 0], // Fades out
                transition: { duration: 1, repeat: Infinity, delay: 0.4 },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default WattingPage;
